import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment-timezone'

function DateField({
  name,
  onChange,
  label,
  value,
  additionalClass,
  isError,
  errorLabel,
  style,
  ...props
}) {
  return (
    <div className="field field-date" style={style}>
      {label && (
        <label className="label" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="control" style={{ position: 'initial' }}>
        <DatePicker
          name={name}
          selected={value ? moment(value).toDate() : null}
          className={`input ${additionalClass || ''} ${isError && 'is-danger'}`}
          onChange={(value) => onChange({ target: { name, value } })}
          dateFormat="MM/dd/yyyy"
          popperPlacement="top-start"
          fixedHeight={true}
          autoComplete="off"
          {...props}
        />
        {errorLabel && isError && <span className={'label--error'}>{errorLabel}</span>}
      </div>
    </div>
  )
}

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  additionalClass: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  min: PropTypes.number,
  isError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorLabel: PropTypes.string,
  style: PropTypes.object,
}

DateField.defaultValue = {
  isError: false,
}

export default DateField
